// Whitelist of lead fields read by the creators list UI + expanded
// collector/deleted_by relations. Passed as `fields=` to PB so the
// payload skips ~30 unused columns (notes, bio, post_caption, AI
// reasoning/raw response, etc.). Cuts response size ~5x and parsing
// time accordingly. Keep this in sync with creator-table-cells.tsx,
// creator-table-row.tsx and any modal launched from the list — if a
// new field is rendered in any of them, add it here or it will be
// undefined at runtime.
export const CREATOR_LIST_FIELDS = [
  'id',
  'ig_username',
  'display_name',
  'photo',
  'profile_photo',
  'followers',
  'category',
  'creator_type',
  'rank',
  'status',
  'created',
  'post_url',
  'is_void',
  'deleted_at',
  'alert_pending_at',
  'ai_analysis_status',
  'appeal_status',
  'user_deleted_at',
  'collector',
  'expand.collector.id',
  'expand.collector.first_name',
  'expand.collector.last_name',
  'expand.collector.photo',
  'expand.collector.ig_username',
  'expand.collector.has_used_redemption',
  'expand.collector.redemption_passed_at',
  'expand.collector.account_status',
  'expand.deleted_by.id',
  'expand.deleted_by.first_name',
  'expand.deleted_by.last_name',
  'expand.deleted_by.ig_username',
].join(',');
